
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import AOS from "aos";
import "aos/dist/aos.css";
import "./assets/fonts/icomoon/style.css"
import "./assets/fonts/flaticon/font/flaticon.css"
import Layout from './ui/Layout.jsx';
import ReactCover from './components/ReactCover';
import Preloader from './components/Preloader'
import Home from './pages/Home.jsx'

function App() {

   useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);
  return (
    <div>
      <Router basename="/">
        <Routes>
          <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="*" element={<ReactCover/>} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
